import { useLocation, useNavigate } from "react-router-dom";
import Header from "../components/Common/Header";

export default function RepaymentStatus({ success }) {
  const location = useLocation();
  const navigate = useNavigate();

  const params = new URLSearchParams(location.search);
  const state = location.state || {};

  // Easebuzz may redirect here either as a browser navigation carrying
  // React Router state, or as a plain GET with the transaction fields
  // appended as query params (e.g. txnid, amount, status, easepayid).
  const txnid = state.txnid || params.get("txnid");
  const amount = state.amount || params.get("amount");
  const status = state.status || params.get("status");

  const accent = success ? "#7BC4E0" : "#FF6B6B";

  return (
    <>
      <Header title={success ? "Payment Successful" : "Payment Failed"} />
      <div className="w-full min-h-screen flex flex-col items-center justify-center bg-[#0A1620] text-white px-4 py-12">
        <div className="w-full max-w-md bg-[#1A2F3A] border border-[#2D5F7A]/30 rounded-xl shadow-lg p-8 flex flex-col items-center text-center">
          <div
            className="w-20 h-20 rounded-full flex items-center justify-center mb-4"
            style={{ backgroundColor: success ? "rgba(123,196,224,0.15)" : "rgba(255,107,107,0.15)" }}
          >
            {success ? (
              <svg className="w-12 h-12" style={{ color: accent }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            ) : (
              <svg className="w-12 h-12" style={{ color: accent }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            )}
          </div>

          <h2 className="text-2xl font-bold mb-2" style={{ color: accent }}>
            {success ? "Payment Successful!" : "Payment Failed"}
          </h2>
          <p className="text-[#CCE6F5] mb-6">
            {success
              ? "Your payment has been processed successfully."
              : "There was an issue processing your payment. Please try again."}
          </p>

          {(txnid || amount || status) && (
            <div className="w-full bg-[#0F2128] border border-[#2D5F7A]/30 rounded-lg p-4 mb-6 text-sm text-left space-y-1">
              {txnid && (
                <p className="text-[#8FAFC7]">
                  Transaction ID: <span className="text-white font-medium">{txnid}</span>
                </p>
              )}
              {amount && (
                <p className="text-[#8FAFC7]">
                  Amount: <span className="text-white font-medium">₹{amount}</span>
                </p>
              )}
              {status && (
                <p className="text-[#8FAFC7]">
                  Status: <span className="text-white font-medium">{status}</span>
                </p>
              )}
            </div>
          )}

          <button
            onClick={() => navigate("/repayloan")}
            className="bg-[#2D5F7A] hover:bg-[#1E3B4A] text-white font-semibold py-3 px-8 rounded-lg transition-all"
          >
            {success ? "Back to Repayment" : "Try Again"}
          </button>
        </div>
      </div>
    </>
  );
}
